import { SoundManager } from '@orbital/slot-lib';
import { GameConfigs } from '../globals/GameConfigs';

//install AudioSprite https://github.com/tonistiigi/audiosprite
//npm install -g audiosprite
//install ffmpec for macos "brew install ffmpeg"
//Step1 change directory to sounds folder "cd public/assets/sounds"
//Step2 generate sound sprite "audiosprite --format howler --output cosmosounds *.mp3"

export const soundManager = new SoundManager(GameConfigs);
